import React, {useState} from 'react';
import commonStyles, {FONT_FAMILY, FONT_SIZE, THEME_COLORS} from "../styles";
import {Text, StyleSheet, TouchableOpacity, View} from "react-native";
import {ModalView} from "./index";
import {getFileNameFromURL, getTrimmedFileName} from "../helper";

interface IWhatsAppMessageData {
    message: any;
}

const WhatsAppMessage = (props: IWhatsAppMessageData) => {
    const {message} = props;
    const [isImageMessageVisible, setIsImageMessageVisible] = useState(false);

    return (
        <>{
            // Message of Image Type
            message.type === "IMAGE" ?
                <><TouchableOpacity onPress={() => {
                    setIsImageMessageVisible(true);
                }}>
                    <img
                    src={message.url}
                    style={{
                        margin: 1,
                        width: "100%",
                        height: "100%"
                    }}
                    alt={getTrimmedFileName(getFileNameFromURL(message.url))}/>
                </TouchableOpacity>
                { !!message.text ?
                    <Text style={{
                        color: THEME_COLORS.black,
                        paddingHorizontal: 2
                    }}>
                      {message.text}
                    </Text> : <></>}</>:

            // Message of Text Type
            message.type === "TEXT" ?
                <Text
                    style={{
                        color: THEME_COLORS.black,
                        paddingHorizontal: 10
                    }}
                >
                    {message.text}
                </Text> :


            // Message of Document/Audio Type
                <View>
                    <TouchableOpacity onPress={() => {
                        !!message.url && window.open(message.url.toString());
                    }} style={[style.pageStyle]}>
                        <img src={require('../../assets/file.png')} style={{width: "40px", height: "40px"}}/>
                        {!!message.url ?
                            <Text style={{marginLeft: 5}}>{getTrimmedFileName(getFileNameFromURL(message.url))}</Text> :
                            <></>}
                    </TouchableOpacity>
                </View>
        }
            <ModalView
                show={isImageMessageVisible}
                onClose={() => {
                    setIsImageMessageVisible(false);
                }}
                headerContent={<Text style={{color: THEME_COLORS.white, fontWeight: "bold"}}>Image</Text>}
                size={"medium"}
            >
                <View style={{height: "95%", width: "100%", alignItems: "center"}}>
                    <img
                        src={message.url}
                        style={{
                            width: "auto",
                            height: "inherit",
                            maxWidth: "100%"
                        }}
                        alt={getTrimmedFileName(getFileNameFromURL(message.url))}
                    />
                </View>
            </ModalView>
        </>
    );
}


const style = StyleSheet.create({
    pageStyle: {
        padding: 2,
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
    }
});

export default WhatsAppMessage;